<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">{{ "" }}</h2>

<mat-dialog-content style="max-height: none">
    <embed [src]="src" style="width: 100%; height: 100%" />
</mat-dialog-content>
